<!-- SIDEBAR 1: Lista de contas Facebook -->
<p-sidebar [(visible)]="visible" class="ss-g-custom-sidebar-width ss-l-class-metaApp" position="right" [modal]="!isMobile"
    (onHide)="visibleChange.emit(false); close.emit()" [style]="{'display': 'flex', 'flex-direction': 'column'}">

    <ng-template pTemplate="header">
        <h4 class="mb-0">Apps &gt; Instagram Business</h4>
    </ng-template>

    <div style="flex: 1 1 auto; overflow-y: auto;" class="sidebar-content">
        <app-feed-help [text]="'Instagram'" [videoUrl]="'https://youtube.com/video-tutorial'"
            [supportUrl]="'https://meusite.com/suporte'">
        </app-feed-help>

        <ng-container *ngIf="!loading; else sidebarSkeleton">
        <ng-container *ngIf="instagramAccounts.length > 0">
            <div class="card shadow-none">
                <div class="text-900 text-xl font-semibold mb-4">
                    Contas <small class="text-sm">({{ instagramAccounts.length }})</small>
                </div>

                <div *ngFor="let acct of instagramAccounts" class="card shadow-none border-1 surface-border mb-2 cursor-pointer"
                    style="position: relative;" (click)="openIgSettings(acct)">

                    <!-- Botão remover (X) -->
                    <button pButton pRipple type="button" icon="pi pi-times"
                        class="p-button-sm p-button-primary text-sm"
                        style="position: absolute; top: -0.5rem; right: -0.5rem; width: 1.75rem; height: 1.75rem; border-radius: 4px; z-index: 10; padding: 0;"
                        (click)="$event.stopPropagation(); onRemoveInstagramAccount(acct)">
                    </button>

                    <div class="flex align-items-center justify-content-between">
                        <div class="flex align-items-center gap-2">
                            <img [src]="acct.picture || 'assets/avatar-placeholder.png'" alt="avatar"
                                style="width: 32px; height: 32px; border-radius: 12%;" />
                            <div>
                                <div class="font-semibold">{{ acct.username }}</div>
                                <div class="text-xs text-500">{{ acct.uid }}</div>
                            </div>
                        </div>
                        <div class="flex align-items-center gap-2">
                            <i class="pi pi-check-circle text-green-600 text-lg"></i>
                            <i class="pi pi-chevron-right text-500"></i>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <!-- Adicionar conta -->
        <div class="card cursor-pointer border-dashed border-1 surface-border flex flex-column justify-content-center align-items-center ss-g-hover-border2 text-center shadow-none"
            style="padding: 1.5rem;" (click)="onAddInstagramAccount()">
            <img src="assets/logo_instagram_recortado.png" width="36" class="mb-2" />
            <span class="font-semibold mb-1">Instagram Business</span>
            <span class="text-sm text-500 mb-2">A autenticação é feita via Facebook</span>
            <button type="button" class="ss-l-fb-btn" (click)="$event.stopPropagation(); onAddInstagramAccount()">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="white" style="flex-shrink:0">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
                Continuar com Facebook
            </button>
        </div>
        </ng-container>

        <ng-template #sidebarSkeleton>
            <div class="card shadow-none">
                <p-skeleton width="8rem" height="1.5rem" styleClass="mb-4"></p-skeleton>
                <div class="flex align-items-center gap-2 mb-3">
                    <p-skeleton shape="circle" size="2rem"></p-skeleton>
                    <div class="flex-1">
                        <p-skeleton width="60%" height="1rem" styleClass="mb-1"></p-skeleton>
                        <p-skeleton width="40%" height="0.75rem"></p-skeleton>
                    </div>
                </div>
                <div class="flex align-items-center gap-2">
                    <p-skeleton shape="circle" size="2rem"></p-skeleton>
                    <div class="flex-1">
                        <p-skeleton width="60%" height="1rem" styleClass="mb-1"></p-skeleton>
                        <p-skeleton width="40%" height="0.75rem"></p-skeleton>
                    </div>
                </div>
            </div>
            <p-skeleton width="100%" height="160px"></p-skeleton>
        </ng-template>
    </div>

    <ng-template pTemplate="footer">
        <div style="text-align: right; padding: 0 1rem 1rem;">
            <button pButton pRipple label="Fechar" class="p-button-outlined"
                (click)="visibleChange.emit(false); close.emit()">
            </button>
        </div>
    </ng-template>
</p-sidebar>

<!-- SIDEBAR 2: Configurações da conta FB -->
<p-sidebar [(visible)]="showIgSettings" class="ss-g-custom-sidebar-width" position="right"
    [modal]="!isMobile" (onHide)="closeIgSettings()"
    [style]="{'display': 'flex', 'flex-direction': 'column'}">

    <ng-template pTemplate="header">
        <div class="flex align-items-center gap-3">
            <span style="width:38px; height:38px; border-radius:50%; background:var(--primary-100, #ede9fe); display:inline-flex; align-items:center; justify-content:center; flex-shrink:0;">
                <i class="pi pi-cog" style="color:var(--primary-700, #3730a3); font-size:1.1rem;"></i>
            </span>
            <div>
                <div class="font-bold text-lg line-height-1">Configurações da conta</div>
                <div class="text-xs text-500 mt-1">Instagram Business vinculado ao Facebook</div>
            </div>
        </div>
    </ng-template>

    <div style="flex: 1 1 auto; overflow-y: auto;" class="sidebar-content">

        <!-- Card externo que envolve tudo -->
        <div class="card">

            <!-- Conta Facebook (fundo levemente diferente) -->
            <div *ngIf="selectedFbAccount" class="surface-100 border-round p-3 mb-3">
                <div class="flex align-items-center justify-content-between">
                    <div class="flex align-items-center gap-3">
                        <div style="width:40px; height:40px; border-radius:10px; overflow:hidden; flex-shrink:0; background:#1877f2; display:flex; align-items:center; justify-content:center;">
                            <img [src]="selectedFbAccount.picture || 'assets/avatar-placeholder.png'" alt="fb"
                                style="width:100%; height:100%; object-fit:cover;" />
                        </div>
                        <div>
                            <div class="font-semibold text-sm">{{ selectedFbAccount.username }}</div>
                            <div class="text-xs text-500">Facebook/Page ID: {{ selectedFbAccount.uid }}</div>
                        </div>
                    </div>
                    <p-tag value="Conectada" severity="success"></p-tag>
                </div>
            </div>

            <!-- Cabeçalho seção IG -->
            <div class="flex align-items-center justify-content-between mb-1">
                <div>
                    <div class="font-semibold text-sm">Contas Instagram vinculadas</div>
                    <div class="text-xs text-500">Configure permissões e automações por perfil</div>
                </div>
                <p-badge *ngIf="igPages.length > 0" [value]="igPages.length.toString()" severity="info"></p-badge>
            </div>
            <p-divider></p-divider>

            <!-- Loading -->
            <ng-container *ngIf="loadingIgPages">
                <p-skeleton height="64px" styleClass="mb-2 w-full"></p-skeleton>
                <p-skeleton height="64px" styleClass="mb-2 w-full"></p-skeleton>
            </ng-container>

            <!-- Lista de contas IG -->
            <ng-container *ngIf="!loadingIgPages">
                <div *ngIf="igPages.length === 0" class="text-center text-500 mt-4 text-sm">
                    Nenhuma conta Instagram encontrada para esta conta Facebook.
                </div>

                <div *ngFor="let page of igPages" class="card shadow-none border-1 surface-border mb-2 p-0">

                <!-- Header do item (sempre visível) -->
                <div class="flex align-items-center justify-content-between p-3 cursor-pointer"
                    (click)="togglePageExpanded(page.id)">
                    <div class="flex align-items-center gap-2">
                        <div style="width:38px; height:38px; border-radius:10px; overflow:hidden; flex-shrink:0; background: linear-gradient(45deg,#f09433,#e6683c,#dc2743,#cc2366,#bc1888); display:flex; align-items:center; justify-content:center;">
                            <img *ngIf="page.ig_picture" [src]="page.ig_picture" alt="ig"
                                style="width:100%; height:100%; object-fit:cover;" />
                            <i *ngIf="!page.ig_picture" class="pi pi-instagram text-white text-lg"></i>
                        </div>
                        <div>
                            <div class="font-semibold text-sm">{{ page.ig_username || 'Conta Instagram' }}</div>
                            <div class="text-xs text-500">@{{ page.ig_username }}</div>
                        </div>
                    </div>
                    <div class="flex align-items-center gap-2">
                        <span class="cursor-pointer" style="width:22px; height:22px; border-radius:50%; background:var(--surface-200, #e2e8f0); display:inline-flex; align-items:center; justify-content:center; flex-shrink:0;"
                            (click)="openInstagramProfile(page.ig_username, $event)">
                            <i class="pi pi-instagram text-500" style="font-size:0.65rem;"></i>
                        </span>
                        <p-tag value="Vinculada" severity="success" [style]="{'font-size':'0.7rem'}"></p-tag>
                        <i class="pi transition-transform"
                            [ngClass]="isPageExpanded(page.id) ? 'pi-chevron-up' : 'pi-chevron-down'">
                        </i>
                    </div>
                </div>

                <!-- Switches (expansível) -->
                <div *ngIf="isPageExpanded(page.id)" class="px-3 pb-3 border-top-1 surface-border">

                    <!-- Switch 1: Menções -->
                    <div class="flex align-items-start justify-content-between pt-3 mb-3">
                        <div class="flex-1 mr-3">
                            <div class="text-sm font-medium">Capturar mídias em que esta conta foi mencionada</div>
                            <div class="text-xs text-500 mt-1">Captura mídias em que este perfil Instagram foi mencionado.</div>
                        </div>
                        <p-inputSwitch [(ngModel)]="page.mentions_enabled"
                            (onChange)="onToggleMentionsEnabled(page)">
                        </p-inputSwitch>
                    </div>

                    <!-- Switch 2: Auto publicar -->
                    <div class="flex align-items-start justify-content-between"
                        [ngClass]="{'opacity-50': !page.mentions_enabled}">
                        <div class="flex-1 mr-3">
                            <div class="text-sm font-medium">Auto-publicar mídias mencionadas</div>
                            <div class="text-xs text-500 mt-1">Disponível apenas quando a captura de menções estiver ativa.</div>
                        </div>
                        <p-inputSwitch [(ngModel)]="page.mentions_auto_publish"
                            [disabled]="!page.mentions_enabled">
                        </p-inputSwitch>
                    </div>
                </div>
            </div>
        </ng-container>

        </div><!-- fim card externo -->

    </div>

    <ng-template pTemplate="footer">
        <div class="flex justify-content-end gap-2" style="padding: 0 1rem 1rem;">
            <button pButton pRipple label="Fechar" class="p-button-outlined"
                (click)="closeIgSettings()">
            </button>
            <button pButton pRipple label="Salvar configurações"
                [icon]="savingSettings ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
                [disabled]="savingSettings || !hasUnsavedChanges"
                (click)="saveAllSettings()">
            </button>
        </div>
    </ng-template>
</p-sidebar>
<p-toast></p-toast>
